export default __webpack_public_path__ + "static/media/Step 4 Image.71404cef.png";